import React, { useState } from "react";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import mock01 from '../assets/images/mock01.png';
import mock02 from '../assets/images/mock02.png';
import mock03 from '../assets/images/mock03.png';
import mock04 from '../assets/images/mock04.png';
import mock05 from '../assets/images/mock05.png';
import mock06 from '../assets/images/mock06.png';
import IEEE_Pic from '../assets/images/IEEE_Pic.png';
import Thesis_Pic from '../assets/images/Thesis_Pic.png' 
import Adv_Pic from '../assets/images/Adv_Pic.png'
import '../assets/styles/Research.scss';

function Research() {
    const [showMore, setShowMore] = useState(false);

    const researchItems = [
        {
            id: 1,
            title: "Cross-view Geo-localization: A Survey",
            description: "This paper, published in IEEE Access, presents a comprehensive survey of state-of-the-art methodologies and challenges in cross-view geo-localization, emphasizing feature-based and deep learning approaches. It explores benchmark datasets, evaluation metrics, and future research avenues, showcasing the transformative potential of CVGL in global applications.",
            imgSrc: IEEE_Pic,
            link: "https://ieeexplore.ieee.org/document/10769461",
        },
        {
            id: 2,
            title: "Thesis Defence",
            description: "Sucessfully defended my thesis on CVGL. I presented on Brigdging the Domain Gap in the Era of Transformers in Cross View Geo Localization",
            imgSrc: Thesis_Pic,
            link: "https://youtu.be/wkKguZjZgjg",
        },
        {
            id: 3,
            title: "Adversarial Attack on CVGL",
            description: "Studied the effect of PGD attack on retrival accuracy in Cross View Geo Localization.",
            imgSrc: Adv_Pic,
            link: "https://youtu.be/H9xGw6GOomE",
        }
    ];

    return (
        <div className="research-container" id="research">
            <h1>Research Blog</h1>
            <div className={`research-grid ${showMore ? "show-all" : ""}`}>
                {researchItems.map((item) => (
                    <div className="research-item" key={item.id}>
                        <a href={item.link} target="_blank" rel="noreferrer">
                            <img src={item.imgSrc} className="zoom" alt="thumbnail" width="100%" />
                        </a>
                        <a href={item.link} target="_blank" rel="noreferrer">
                            <h2>{item.title}</h2>
                        </a>
                        <p>{item.description}</p>
                    </div>
                ))}
            </div>
            <div className="arrow-container" onClick={() => setShowMore(!showMore)}>
                {showMore ? (
                    <KeyboardArrowUpIcon className="arrow-icon" />
                ) : (
                    <KeyboardArrowDownIcon className="arrow-icon" />
                )}
            </div>
        </div>
    );
}

export default Research;
